export const mainMenuFeatureTranslationEN = {
  MainMenuFeature: {
    todo_list: 'To-do List',
  },
};
